import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {take, takeUntil} from 'rxjs/operators';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {EventStatus} from '@shared/models/notification-message.model';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {Api} from '@shared/constants/common-field.constants';
import {AddCompanyAction} from '@features/admin-panel/store/actions/admin-panel.action';
import {AddCompanyCommand} from '@features/admin-panel/commands/admin-panel.command';
import {AddCompanyComponent} from '@features/admin-panel/components/add-company/add-company.component';
import {MatDialog} from '@angular/material/dialog';
import {UserInfo} from '@shared/models/user-info.model';
import {AdminPanelState} from '@features/admin-panel/store/reducers/admin-panel.reducer';
import {select, Store} from '@ngrx/store';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {Clipboard} from '@angular/cdk/clipboard';
import { FileManagementService } from '@core/services/file-management.service';

@Injectable({
  providedIn: 'root',
})
export class AdminPanelPartnerCompanyHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  userInfo: UserInfo;
  selectedTabModel: TabModel;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private dialog: MatDialog,
              private router: Router,
              private store: Store<AdminPanelState>,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private dialogService: DialogService,
              private clipboard: Clipboard,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }

  destroy(): void {
    this.invalidateSubject.close();
  }

  onBeforeLoad(): void {
    this.store.pipe(select(getUserInfo), take(1)).subscribe(u => {
      this.userInfo = u;
    });
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']).then();
    } else {
      this.executeCommandToApi(command);
    }
  }

  executeCommandToApi(command: PlatformCommand) {
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
      this.fuseSplashScreenService.hide();
      if (commandResponse.fieldValues['SnackBarMessage']) {
        if (commandResponse.status === EventStatus.Success) {
          this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage']);
        } else {
          this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
        }
      }
      if (commandResponse.fieldValues['ShowWarning']) {
        this.snackBarService.showWarning(commandResponse.fieldValues['ShowWarning']);
      }
      if (commandResponse.fieldValues['ShowErrorMessage']) {
        this.snackBarService.showError(commandResponse.fieldValues['ShowErrorMessage']);
      }
      if (commandResponse.fieldValues['RedirectCommand']) {
        this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
        return;
      } else if (commandResponse.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']).then();
        return;
      } else if (commandResponse.fieldValues['PlatformLinkModel']) {
        this.magicLinkModelValueChanged.emit({
          id: 'PlatformToolContainerComponent',
          value: commandResponse.fieldValues['PlatformLinkModel']
        });
      } else if(commandResponse.fieldValues['DownloadResponse']){
        this.fuseSplashScreenService.hide();
        this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues['DownloadResponse'].fileId).subscribe(payload => {
          this.fileManagementService.openSaveFileWindow(payload, `${commandResponse.fieldValues['DownloadResponse'].fileName}`);
        });
        return;
      }else {
        this.invalidateSubject.invalidate();
      }
    },
      error => {
        console.error('Failed ' + command.name, error);
        this.fuseSplashScreenService.hide();
      });
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  valueChanged($event) {
    if ($event.action) {
      this.handleAction($event);
    }
  }

  private handleAction($event: any) {
    if ($event.action.id == 'Edit') {
      this.openEditor($event);
    }
  }
  openEditor(event: any) {
    const minWidth = '800px';
    const maxWidth = '1500px';
    let sourceType = this.magicLinkModel.fieldValues['SourceType'];
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,sourceType).subscribe(state => {
      if (state.action === 'OK') {
         let value = event.item.cells[event.fieldDefinition.key]?.value;
         let editFieldCommand = this.getEditFieldCommand(value, event);
         this.executeCommandToApi(editFieldCommand);
      }
    });
  }

  private getEditFieldCommand(value: any, event: any) {
    let editFieldCommand = new PlatformCommand("EditAdminPanelCompanySubscriptionFieldsCommand", Api.AdminPanel);
    editFieldCommand.fieldValues['NewValue'] = value;
    editFieldCommand.fieldValues['FieldKey'] = event.fieldDefinition.key;
    editFieldCommand.fieldValues['ItemId'] = event.item.id;
    return editFieldCommand;
  }
}
